<template>
	<div class="candash-footer">
		<div class="d-flex align-items-center">
			<div class="candash-footer-txt">COPYRIGHT HIRE3X 2026 -</div>
			<div class="candash-footer-txt-2 ml-3">USER AGREEMENT</div>
			<div class="candash-footer-txt-2 ml-3 pointer" @click="goToTerms()">
				TERMS & CONDITIONS
			</div>
			<div
				class="candash-footer-txt-2 ml-3 pointer"
				@click="goToPrivacyPolicy()"
			>
				PRIVACY POLICY
			</div>

			<div class="d-flex ml-5">
				<div>
					<a
						href="https://www.instagram.com/hire3x?igsh=MWQ0bzhqandjenprYg=="
						id="insta"
						target="_blank"
					>
						<img src="../../../assets/img/homepage/Instagram.svg" alt=""
					/></a>
				</div>
				<div>
					<a
						href="https://www.facebook.com/profile.php?id=61552725574787&mibextid=AEUHqQ"
						id="fb"
						target="_blank"
					>
						<img
							src="../../../assets/img/homepage/Facebook.svg"
							alt=""
							class="ml-3"
					/></a>
				</div>
				<div>
					<a
						href="https://www.twitter.com/hire3x/"
						id="twitter"
						target="_blank"
					>
						<img
							src="../../../assets/img/homepage/twitter.svg"
							alt=""
							class="ml-3"
					/></a>
				</div>
				<div>
					<a
						href="https://www.linkedin.com/company/hire3x/"
						id="linkedin"
						target="_blank"
					>
						<img
							src="../../../assets/img/homepage/Linkedin.svg"
							alt=""
							class="ml-3"
						/>
					</a>
				</div>
			</div>
		</div>
		<div>
			<img
				src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/Hire3xAssests/Logo/SVG/Hire3xbeta_logo.svg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		goToPrivacyPolicy() {
			window.open(
				"https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/General+Privacy+Policy+for+hire3x.pdf"
			);
		},
		goToTerms() {
			window.open(
				"https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/documents/Terms+and+Conditions+Hire3x.docx"
			);
		},
	},
};
</script>

<style lang="postcss" scoped></style>
